export default {
      id: "i-chart-pie-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-chart-pie",
      toString: function () {
        return this.url;
      }
    }